<template>
  <section class="organization posire">
    <section class="posiab orgBox">
      <qx-card title="组织架构">
        <el-button
          type="primary"
          plain
          slot="titleRight"
          @click="() => toEdit()"
          v-if="checkPermpisions('1100301')"
        >添加部门</el-button>
        <el-tree
          :data="treeData"
          :show-checkbox="false"
          :default-expand-all="true"
          node-key="orgId"
          ref="tree"
          highlight-current
          :props="defaultProps"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
        >
          <section class="clearPa treeNodeBox" slot-scope="{ node, data }">
            <section class="left">{{ node.label }}</section>
            <section class="right btnBox" v-if="data.orgType !== 0">
              <span
                class="del primary cur btn"
                @click="toEdit(data.orgId)"
                v-if="checkPermpisions('1100303')"
              >修改</span>
              <span
                class="del error cur btn"
                @click="del(data.orgId)"
                v-if="checkPermpisions('1100305')"
              >删除</span>
            </section>
          </section>
        </el-tree>
      </qx-card>
    </section>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import {
  orgList,
  orgDel,
} from 'api/system';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      treeData: [],
      defaultProps: {
        children: 'childOragnizes',
        label: 'orgName',
      },
    };
  },
  methods: {
    toEdit (id) {
      // 组织管理-新增部门时组织类型不能有总公司
      let hasHeadOffice = '';
      for (let item of this.treeData) {
        if (item && item.orgType === 0) {
          hasHeadOffice = 'hasHeadOffice=0';
        }
      }
      this.jump({
        label: (id ? '修改' : '新增') + '部门',
        url: `/manage/system/jurisdiction/organization/edit${id ? ('?id=' + id + `&${hasHeadOffice}`) : `?${hasHeadOffice}`}`,
        full: true,
      });
    },
    async del (orgId) {
      const confirmRes = await this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await orgDel({
          orgId,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
    async getData () {
      const res = await orgList();
      this.treeData = res.childOragnizes;
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.treeData[0].orgId);
      });
      this.$refs.tableBox.saveSearchBoxData({
        orgId: this.treeData[0].orgId,
        state: this.treeData[0].state,
        parentOrgType: this.treeData[0].parentOrgType,
        orgName: this.treeData[0].orgName,
      });
    },
    handleNodeClick (data) {
      this.$refs.tableBox.saveSearchBoxData({
        orgId: data.orgId,
        state: data.state,
        parentOrgType: data.parentOrgType,
        orgName: data.orgName,
      });
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.organization {
  padding-left: 328px;
  .orgBox {
    width: 320px;
    height: 100%;
    top: 0;
    left: 0;
    .treeNodeBox {
      width: 100%;
      .btn {
        margin-left: 16px;
      }
    }
  }
  ::v-deep .el-tree-node__content {
    .btnBox {
      display: none;
    }
  }
  ::v-deep .el-tree-node__content:hover {
    .btnBox {
      display: block;
    }
  }
}
</style>
